@if (columns.length > 0) {
  <p-table
    #tableRef
    aria-label="Inbound Faxes Table"
    currentPageReportTemplate="Showing {first}-{last} of {totalRecords} items"
    paginatorDropdownAppendTo="body"
    responsiveLayout="scroll"
    selectionMode="single"
    stateStorage="local"
    [alwaysShowPaginator]="true"
    [columns]="columns"
    [dataKey]="dataKey"
    [filterDelay]="1000"
    [first]="0"
    [lazy]="true"
    [paginator]="true"
    [rows]="rows"
    [rowsPerPageOptions]="[10, 25, 50]"
    [scrollable]="true"
    [showCurrentPageReport]="true"
    [sortField]="sortField"
    [sortOrder]="sortOrder"
    [totalRecords]="total"
    [value]="tableData"
    [stateKey]="stateKey"
    (selectionChange)="selectionTriggered = true"
    (onLazyLoad)="handleLazyLoad($event)"
    (onPage)="handlePage($event)"
    (selectionChange)="selectionChange($event)"
    >
    <ng-template let-columns pTemplate="header">
      <tr>
        @if (multiselect) {
          <th
            class="flex items-center justify-center"
            style="width: 3.5rem"
            >
            <p-tableHeaderCheckbox />
          </th>
        }
        @for (col of columns; track $index) {
          <th
            [pSortableColumn]="col.field"
            [pSortableColumnDisabled]="!col.isSortable"
            [style]="col.styles"
            >
            <div class="flex items-center gap-2">
              {{ col.header }}
              @if (col.isSortable) {
                <p-sortIcon [field]="col.field"/>
              }
            </div>
          </th>
        }
      </tr>
      @if (filterable) {
        <tr class="header-filter">
          @if (multiselect) {
            <th style="width: 3.5rem"></th>
          }
          @for (col of columns; track $index) {
            <th>
              @switch (col.filterConfig?.template) {
                @case (FilterTemplate.MultiSelectFilterTemplate) {
                  <p-columnFilter
                    matchMode="in"
                    [field]="col.field"
                    [showClearButton]="false"
                    [showMenu]="false"
                    >
                    <ng-template let-filter="filterCallback" pTemplate="filter">
                      <p-multiSelect
                        appendTo="body"
                        placeholder="Filter"
                        styleClass="p-column-filter"
                        [ngModel]="col.filterConfig.values"
                        [options]="col.filterConfig.options"
                        [resetFilterOnHide]="true"
                        (onChange)="filter($event.value)"
                        />
                      </ng-template>
                    </p-columnFilter>
                  }
                  @case (FilterTemplate.SearchFilterTemplate) {
                    <div class="p-column-filter-row">
                      <p-iconfield class="filter-iconfield">
                        <p-inputicon class="pi pi-search" />
                        <input
                          pInputText
                          placeholder="Search"
                          type="text"
                          [ngModel]="col.filterConfig.value"
                          (input)="filterText(col.field, $event.target.value)"
                          />
                        </p-iconfield>
                      </div>
                    }
                    @default {
                    }
                  }
                </th>
              }
            </tr>
          }
        </ng-template>
        <ng-template
          let-columns="columns"
          let-rowData
          let-rowIndex="rowIndex"
          pTemplate="body"
          >
          <tr [pSelectableRow]="rowData">
            @if (multiselect) {
              <td style="width: 3.5rem">
                <p-tableCheckbox [value]="rowData" (click)="$event.stopPropagation()" />
              </td>
            }
            @for (col of columns; track $index) {
              <td>
                @switch (col.type) {
                  @case (ColumnType.Button) {
                    <span
                      [pTooltip]="col.buttonConfig.getToolTip(rowData)"
                      tooltipPosition="bottom"
                      tooltipStyleClass="tooltip-xl-size"
                      >
                      <ng-container>
                        <button
                          pButton
                          class="truncate table-button"
                          [disabled]="
                            col.buttonConfig.disabled &&
                            col.buttonConfig.disabled(rowData)
                          "
                          [label]="
                            rowData[col.field]
                              ? col.buttonConfig.buttonLabel || rowData[col.field]
                              : col.buttonConfig.emptyLabel
                          "
                          (click)="col.buttonConfig.onClicked(rowData)"
                          >
                          <span
                            class="pi p-button-icon p-button-icon-left"
                            [ngClass]="
                              rowData[col.field]
                                ? getButtonIcon(col)
                                : getEmptyButtonIcon(col)
                            "
                          ></span>
                        </button>
                      </ng-container>
                    </span>
                  }
                  <!-- Needed dedicated type to handle button spinner. See if we want this standardized for all buttons -->
                  @case (ColumnType.Preview) {
                    <span
                      pTooltip="{{ rowData[col.field] }}"
                      tooltipPosition="bottom"
                      tooltipStyleClass="tooltip-xl-size"
                      >
                      <ng-container>
                        <button
                          pButton
                          class="truncate table-button"
                          [disabled]="rowData['isPreviewLoading']"
                          [label]="
                            rowData[col.field]
                              ? col.buttonConfig.buttonLabel || rowData[col.field]
                              : col.buttonConfig.emptyLabel
                          "
                          [ngClass]="{
                            'p-table-button-clicked': selectedPreviewIndexList.has(
                              rowData[dataKey]
                            )
                          }"
                          (click)="onPreviewClicked(col, rowData)"
                          >
                          <span
                            class="pi p-button-icon p-button-icon-left"
                            [ngClass]="
                              rowData[col.field]
                                ? getButtonIcon(col)
                                : getEmptyButtonIcon(col)
                            "
                          ></span>
                          @if (rowData['isPreviewLoading']) {
                            <i
                              aria-hidden="true"
                              class="pi pi-spin pi-spinner mr-1"
                            ></i>
                          }
                        </button>
                      </ng-container>
                    </span>
                  }
                  <!-- Needed dedicated type button to show/hide based on value -->
                  @case (ColumnType.RestoreButton) {
                    @if (rowData[col.field]) {
                      <button
                        pButton
                        class="truncate table-button"
                        [label]="
                          rowData[col.field]
                            ? col.buttonConfig.buttonLabel || rowData[col.field]
                            : col.buttonConfig.emptyLabel
                        "
                        (click)="col.buttonConfig.onClicked(rowData)"
                        >
                        <span
                          class="pi p-button-icon p-button-icon-left"
                          [ngClass]="
                            rowData[col.field]
                              ? getButtonIcon(col)
                              : getEmptyButtonIcon(col)
                          "
                        ></span>
                      </button>
                    }
                  }
                  @case (ColumnType.UtcToLocal) {
                    {{ rowData[col.field] | utcToLocal : "MM/dd/yyyy hh:mm:ss a" }}
                  }
                  @case (ColumnType.TimeSpent) {
                    {{ rowData[col.field] | timeSpent : "[d] day(s) + [h]h:[m]m" }}
                  }
                  @case (ColumnType.String) {
                    {{ rowData[col.field] | emptyPlaceholder }}
                  }
                  @case (ColumnType.NoteButton) {
                    @if (!rowData[col.field] && rowData['isArchived']) {
                      {{ rowData[col.field] | emptyPlaceholder }}
                    }
                    @if (!rowData[col.field] && !rowData['isArchived']) {
                      <mnc-notes-create-button
                        styleClass="table-button"
                        [noteConfig]="rowData['noteConfig']"
                        [noteType]="'inbound-fax-note'"
                        [modal]="true"
                        (noteCreated)="handleLazyLoad(null)"
                        lazyComponent
                        />
                    }
                    @if (rowData[col.field]) {
                      <mnc-notes-view-button
                        [noteId]="rowData[col.field]"
                        [noteType]="'inbound-fax-note'"
                        [tenantId]="rowData['noteConfig'].tenantId"
                        lazyComponent
                        />
                    }
                  }
                  @default {
                  }
                }
              </td>
            }
          </tr>
        </ng-template>
        <ng-template let-columns pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="columns.length + 1">No records found.</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="paginatorleft">
          <!-- empty but allows paginator to be pushed to the right -->
        </ng-template>
      </p-table>
    }

    <mnc-notes-dialog-manager modal="true" lazyComponent />
